import { api } from "../../axiosApi";
import Cookies from "js-cookie";

export const fetchLogin = async (userData) => {
  try {
    const response = await api.post("/api/v1/auth/login", userData);
    console.log("🚀 ~ fetchLogin ~ response:", response)
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};


// export const refreshAccessToken = async () => {
//   try {
//     const response = await api.post("/api/v1/refresh-token", {}, {
//       withCredentials: true,
//     });

//     // Adjust this according to your API response structure
//     const newAccessToken = response?.data?.data?.token || response?.data?.token;

//     if (response?.data?.success && newAccessToken) {
//       localStorage.setItem("access_token", newAccessToken);
//       return newAccessToken;
//     }
// console.log("🔄 New Access Token:", newAccessToken);

//     return null;
//   } catch (error) {
//     console.error("Token refresh failed", error);
//     return null;
//   }
// };

// export const refreshAccessToken = async () => {
//   try {
//     const refreshToken = localStorage.getItem("refresh_token");
//     console.log("📦 Refresh token:", refreshToken);

//     const response = await api.post(
//       "/api/v1/refresh-token",
//       {},
//       {
//         headers: {
//           refreshtoken: refreshToken,
//         },
//       }
//     );

//     console.log("🌐 Refresh response:", response?.data);

//     const newAccessToken = response?.data?.data?.accessToken;

//     if (newAccessToken) {
//       localStorage.setItem("access_token", newAccessToken);
//       console.log("🔄 New access token saved:", newAccessToken);
//       return newAccessToken;
//     } else {
//       console.warn("⚠️ No access token in response");
//       return null;
//     }
//   } catch (error) {
//     console.error("❌ Refresh failed:", error.message);
//     return null;
//   }
// };



export const refreshAccessToken = async () => {
  try {
    const refreshToken = localStorage.getItem("refresh_token") || Cookies.get("refresh_token");
    if (!refreshToken) {
      throw new Error("No refresh token found");
    }

    const response = await api.post(
      "/api/v1/refresh-token",
      {},
      {
        headers: {
          refreshtoken: refreshToken, // ✅ Required by backend
        },
      }
    );

    const newAccessToken = response?.data?.data?.accessToken;
    if (newAccessToken) {
      localStorage.setItem("access_token", newAccessToken);
      return newAccessToken;
    }

    throw new Error("No access token in response");
  } catch (error) {
    console.error("❌ Failed to refresh token:", error?.response?.data || error.message);
    throw error;
  }
};


export const sendLink = async (email) => {
  try {
    const response = await api.post("/api/v1/send-email",{email});
    console.log("🚀 ~ sendLink ~ response:", response)
    return response.data;
  }catch (error) {
    return error?.response?.data;
  }
};



export const newPinSet = async (authData) => {
  try {
    const response = await api.post("/api/v1/set-pin",authData);
    console.log("🚀 ~ sendLink ~ response:", response)
    return response.data;
  }catch (error) {
    return error?.response?.data;
  }
};

export const updateProfile = async (formData) => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await api.post("/api/v1/admin/profile/edit", formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};


export const fetchProfileDetails = async () => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await api.get("/api/v1/admin/profile/details", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const uploadProfileImage = async (file) => {
  try {
    const token = localStorage.getItem("access_token");
    const formData = new FormData();
    formData.append("profilePic", file);

    const response = await api.post("/api/v1/admin/profile/image-edit", formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const fetchCountries = async () => {
  try {
    const response = await api.get("/api/v1/country");
    return response.data?.data || []; // assuming response has { success, data }
  } catch (error) {
    console.error("Error fetching countries:", error);
    return [];
  }
};


export const fetchStates = async (countryId) => {
  try {
    const response = await api.get(`/api/v1/state?countryId=${countryId}`);
    return response.data?.data || [];
  } catch (error) {
    console.error("Error fetching states", error);
    return [];
  }
};


export const fetchCities = async (stateId) => {
  try {
    const response = await api.get(`/api/v1/cities?stateId=${stateId}`);
    // console.log("🌆 Cities fetched:", response.data); // Optional log

    const cities = response?.data?.data;

    return Array.isArray(cities) ? cities : [];
  } catch (error) {
    console.error("Error fetching cities", error);
    return [];
  }
};





// name: Deploy React App to Namecheap

// on:
//   push:
//     branches:
//       - Darshit-development

// jobs:
//   deploy:
//     runs-on: ubuntu-latest

//     steps:
//       - name: Checkout Code
//         uses: actions/checkout@v3

//       - name: Setup Node.js
//         uses: actions/setup-node@v3
//         with:
//           node-version: 18

//       - name: Install Dependencies
//         run: npm install --legacy-peer-deps

//       - name: Build React App
//         run: CI='' npm run build

//       - name: Deploy via FTP to Namecheap
//         uses: SamKirkland/FTP-Deploy-Action@v4.3.4
//         with:
//           server: ${{ secrets.FTP_HOST }}
//           username: ${{ secrets.FTP_USERNAME }}
//           password: ${{ secrets.FTP_PASSWORD }}
//           local-dir: build/
//           server-dir: /
